import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

const people = [
  {
    name: '"Why is content creation taking up so much of our time?"',
    imageUrl: '/images/b2b/pp1.jpeg',
    bio: 'Imagine cutting your content production time in half—Easy-Peasy.AI automates blogs, emails, and marketing materials, so your team can focus on strategy instead of staring at a blank page.',
  },
  {
    name: '"How can we ensure our brand voice never gets lost?"',
    imageUrl: '/images/b2b/pp2.jpeg',
    bio: 'Consistency is key! Easy-Peasy.AI allows you to customize templates and tone, ensuring your brand message is always on point—no matter who is creating it.',
  },
  {
    name: '"Scaling for global audiences feels overwhelming—where do we even start?"',
    imageUrl: '/images/b2b/pp3.jpeg',
    bio: "Speak your audience's language, literally! With multilingual capabilities, Easy-Peasy.AI helps you effortlessly create localized content for any market.",
  },

  {
    name: '"We have a campaign deadline tomorrow! How do we deliver on time?"',
    imageUrl: '/images/b2b/pp4.jpeg',
    bio: "Deadlines won't scare you anymore. Easy-Peasy.AI creates campaign-ready content instantly—social ads, landing pages, and email sequences, all done in minutes.",
  },
  {
    name: '"We are not a creative team—how can we create content that stands out?"',
    imageUrl: '/images/b2b/pp5.jpeg',
    bio: "You don't need to be creative geniuses—Easy-Peasy.AI makes professional-grade content creation as simple as a few clicks. Leave the heavy lifting to us.",
  },
  {
    name: '"How do we justify investing in yet another tool?"',
    imageUrl: '/images/b2b/pp6.jpeg',
    bio: 'Investing in Easy-Peasy.AI is not about adding just another tool—it is about consolidating multiple tools into one powerful, all-in-one platform. Say goodbye to juggling subscriptions and disjointed systems! Whether you need content creation, idea generation, editing, or brand consistency.',
  },
  {
    name: '"Why are we still wasting hours on repetitive tasks?"',
    imageUrl: '/images/b2b/pp7.jpeg',
    bio: "Don't let manual tasks slow you down! Use Easy-Peasy.AI to automate anything from email drafts to report summaries, and reclaim your team's productivity.",
  },
  {
    name: '"We need actionable insights fast—how do we simplify reporting?"',
    imageUrl: '/images/b2b/pp8.jpeg',
    bio: 'Complex data, meet Easy-Peasy.AI. Quickly turn numbers into digestible visual reports and summaries that make decision-making a breeze.',
  },
  {
    name: '"How do we get our team to actually use new tools?"',
    imageUrl: '/images/b2b/pp9.jpeg',
    bio: 'Adoption made easy. With an intuitive interface, quick onboarding, and 24/7 support, Easy-Peasy.AI ensures your team will love using it from day one.',
  },
  {
    name: '"We are worried about security and compliance—how can we trust this?"',
    imageUrl: '/images/b2b/pp10.jpeg',
    bio: 'Trust is key. Easy-Peasy.AI ensures your data is secure and fully compliant with global regulations like ISO27001, SOC2, GDPR, HIPAA, etc. giving you peace of mind.',
  },

  // More people...
];

const B2BPainPoints = () => {
  const { t } = useTranslation('b2b');

  return (
    <div className='bg-white py-24 dark:bg-slate-800 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl sm:text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Do These Challenges Hold You Back?')}
          </h2>
          <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-slate-400'>
            {t('Discover how Easy-Peasy.AI turns your everyday challenges into seamless victories, empowering your team to do more—faster and smarter.')}
          </p>
        </div>
        <ul
          role='list'
          className='mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8 xl:max-w-none'
        >
          {people.map((person) => (
            <li key={person.name} className='flex flex-col gap-6 xl:flex-row'>
              <Image
                className='aspect-square w-52 flex-none rounded-2xl object-cover'
                src={person.imageUrl as string}
                width='208'
                height='208'
                alt=''
              />
              <div className='flex-auto'>
                <h3 className='text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-slate-200'>
                  {t(person.name)}
                </h3>
                <p className='mt-6 text-base leading-7 text-gray-600 dark:text-slate-400'>
                  {t(person.bio)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default B2BPainPoints;
